import styleVariables from '@/assets/scss/variables.module.scss';
import getRandomNumber from '../utilities/getRandomNumber';

export default {
  data() {
    return {
      tagColors: [
        styleVariables.pink500,
        styleVariables.error500,
        styleVariables.warning500,
        styleVariables.success500,
        styleVariables.primary500,
        styleVariables.purple500,
        styleVariables.gray500,
      ],
    };
  },

  computed: {
    currentTeamId() {
      return this.$store.getters.getTeamID;
    },

    currentProjectId() {
      if (this.$store.getters.getQuickCardIsOn || this.$store.getters.getChildCardCreation) {
        // getCurrentQuickCardProjectId is initialized in CardTagsViewPopup component
        return this.getCurrentQuickCardProjectId ?? this.$store.getters.getQuickCardProjectId;
      }
      if (
        [
          this.$constants.settingsTemplate.card.create.name,
          this.$constants.settingsTemplate.card.edit.name,
        ].includes(this.$route.name)
      ) {
        return this.$store.getters.getFlatBoards[
          this.$store.getters.getCardTemplateDraft.card_board_id
        ]?.project_id;
      }

      return this.currentCard.project_id;
    },

    tags() {
      return this.$store.getters.getTags;
    },

    projectTags() {
      return this.$store.getters.getProjectTags(this.currentProjectId);
    },

    workspaceTags() {
      return this.$store.getters.getWorkspaceTags(this.currentTeamId);
    },

    projectWorkspaceTags() {
      if (this.isEpic) return [...this.workspaceTags];
      return [...this.projectTags, ...this.workspaceTags];
    },

    tagsLength() {
      return this.projectWorkspaceTags.length;
    },
  },

  methods: {
    selectColor(color) {
      // disable selecting color only when adding first tag
      if (this.projectWorkspaceTags && !this.tagsLength && !this.searchValue) {
        this.focusInput();
        return;
      }
      this.selectedColor = color;
    },

    selectRandomColor() {
      if (this.selectedColor) return;
      // Select random color from tagColors array
      const randomNumber = getRandomNumber(0, this.tagColors.length - 1);
      this.selectedColor = this.tagColors[randomNumber];
    },
  },
};
